import React, { ReactElement, useEffect, useRef, useState } from 'react';

// 样式
import { convertStyles } from '@kibt/krn-utils';

import { KView, KText, PageContext, KScrollView } from '@/component/RtlLayout';
import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);
import MyImage from '../MyImage';
import Close from '@/assets/icon_detail/close.png';
import CouponCardLarge from '../CouponCardLarge';
import iconRight from '@/assets/icon/icon_right.png';

import Popup from '@kibt/meta-ui-krn/lib/components/Popup';
import { $k18n } from '@/common/i18n';

import { getQueryDetailCouponListAPI } from '../../../api';
import { vIf } from '@/common/utils/vIf';
import { logClickMore, logShowCouponPanel } from '../../../logger2.0';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { AdjustPCStyle, PCMaxWidth, PCMaxWidthRemValue, isIOS, isInApp, isMobileDeviceValue } from '@/common/device-info';
import { onForbidWebDrag } from '@/common/hooks';
import { useCouponPush } from '@/hooks/abTest/useCouponPush';
import { useQuery } from '@/hooks/useQuery';
import { CouponPopupSke } from './couponPopupSke';
import { reportCatchError } from '@/utils/reportCatchError';
import { useDetailPageStore } from '@/page/detail/store';
import { allowDefaultOutsideClick, ignoreOutsideClick, onClickContainerOutside } from '@/common/utils/clickOnContinerOutSide';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { useMemoizedFn } from 'ahooks';
import { useCallApp } from '@/common/callApp';

function CouponLinePop(): ReactElement {
    const setStore = useDetailPageStore().setState;
    const { pageRawData, isPopVisible, refreshCouponList } = useDetailPageStore(store => ({
        pageRawData: store.pageRawData,
        isPopVisible: store.showMoreCouponPopVisible,
        refreshCouponList: store.refreshCouponList,
    }));
    const shopInfo = pageRawData?.shop;
    const setShowMoreCouponPopVisible = (show: boolean) =>
        setStore({
            showMoreCouponPopVisible: show,
        });

    const closeShowMoreCouponPop = () => {
        setShowMoreCouponPopVisible(false);
        allowDefaultOutsideClick();
    };

    const showMoreCouponPop = () => {
        setShowMoreCouponPopVisible(true);
        ignoreOutsideClick();
        onClickContainerOutside(() => {
            closeShowMoreCouponPop();
        });
    };

    useEffect(() => {
        setStore({
            showMoreCouponPop: showMoreCouponPop,
        });
    }, []);

    const [shippingUsableCoupons, setShippingUsableCoupons] = useState([]);
    const [goodsUsableCoupons, setGoodsUsableCoupons] = useState([]);
    const [openAllShippList, setOpenAllShippList] = useState(false);
    const { couponPush } = useCouponPush();

    // 分场景下发优惠券
    const scene = useQuery('scene') as string;
    const couponListSceneMap = {
        20: 21, // 小黄车列表
        22: 23, // 短视频主商品
        34: 35, // 短视频推荐列表
        102: 102, // 分销寄样来源
    };
    const mapScene = couponListSceneMap?.[scene];

    const fetchData = async () => {
        // 商详页透传给营销的参数，根据相关参数来获取对应的优惠券列表
        const conponParams = [
            {
                categoryIds: pageRawData?.categoryIdList || [],
                freeShipment: pageRawData?.serviceRule?.expressFeeType === 1, // 是否包邮, 运费计算失败的case是否需要考虑
                itemId: pageRawData?.itemId, // 商品id
                merchantId: pageRawData?.merchantId, // 商家id
                price: pageRawData?.itemPrice, // 商品最小单价
                shopId: pageRawData?.shop?.merchantId, // 店铺id
                // skuId: pageRawData.skuId,
            },
        ];
        try {
            const detailDataRes = await getQueryDetailCouponListAPI({
                itemCouponParam: conponParams,
                scene: mapScene,
            }).catch(err =>
                reportCatchError(err, {
                    position: 'getQueryDetailCouponListAPI',
                })
            );
            if (detailDataRes?.result === 1) {
                const itemCoupons = detailDataRes.data?.[0]?.itemCoupon;
                const shippingUsableCoupons = itemCoupons.filter(i => i.discountFeeType === 3);
                const goodsUsableCoupons = itemCoupons.filter(i => i.discountFeeType === 2);
                setShippingUsableCoupons(shippingUsableCoupons);
                setGoodsUsableCoupons(goodsUsableCoupons);
            } else {
                // setPageError(true);
            }
        } catch (error) {
            console.log('接口挂了', error);
        }
    };

    useEffect(() => {
        // 优惠券半屏列表拉起时，请求营销接口数据渲染优惠券列表信息
        if (isPopVisible) {
            fetchData();
        }
        // 弹窗时调用客户端的桥，禁止拖拽外层容器
        const changeSpecPopupShow = show => {
            if (isInApp) {
                onForbidWebDrag(show);
            }
        };
        changeSpecPopupShow(isPopVisible);
    }, [isPopVisible]);

    const shippingCoupons = () => {
        return pageRawData?.serviceRule?.expressFeeType === 1 || !shippingUsableCoupons || !shippingUsableCoupons.length
            ? null
            : (() => {
                  return (
                      <>
                          <KText rtlClassName={'coupon-options-title'}>{$k18n({ text: '运费券', id: 'k_343745' })}</KText>

                          {shippingUsableCoupons && shippingUsableCoupons[0]
                              ? [shippingUsableCoupons[0]].map((couponInfo, index) => {
                                    return (
                                        <CouponCardLarge
                                            shopInfo={shopInfo}
                                            coupon={couponInfo}
                                            updateMiniCouponInfo={refreshCouponList}
                                            itemInfo={{
                                                itemId: pageRawData.itemId,
                                            }}
                                        />
                                    );
                                })
                              : null}

                          {shippingUsableCoupons && shippingUsableCoupons.length > 1 && openAllShippList ? (
                              <>
                                  {shippingUsableCoupons.slice(1).map((couponInfo, index) => {
                                      return (
                                          <CouponCardLarge
                                              shopInfo={shopInfo}
                                              coupon={couponInfo}
                                              updateMiniCouponInfo={refreshCouponList}
                                              itemInfo={{
                                                  itemId: pageRawData.itemId,
                                              }}
                                          />
                                      );
                                  })}
                                  <KTouchableWithoutFeedback
                                      onPress={() => {
                                          setOpenAllShippList(false);
                                      }}>
                                      <KView rtlClassName={'option-btn-wrap'}>
                                          <KText rtlClassName={'option-btn-view-more'}>{$k18n({ text: '展示更少', id: 'k_343238' })}</KText>
                                          <MyImage imageSrc={iconRight} styleObj={{ width: 16, height: 16, transform: [{ rotate: '-90deg' }] }} />
                                      </KView>
                                  </KTouchableWithoutFeedback>
                              </>
                          ) : null}

                          {shippingUsableCoupons && shippingUsableCoupons.length > 1 && !openAllShippList ? (
                              <>
                                  <KTouchableWithoutFeedback
                                      onPress={() => {
                                          logClickMore();
                                          setOpenAllShippList(true);
                                      }}>
                                      <KView rtlClassName={'option-btn-wrap'}>
                                          <KText rtlClassName={'option-btn-view-more'}>{$k18n({ text: '展示更多', id: 'k_343237' })}</KText>
                                          <MyImage imageSrc={iconRight} styleObj={{ width: 16, height: 16, transform: [{ rotate: '90deg' }] }} />
                                      </KView>
                                  </KTouchableWithoutFeedback>
                              </>
                          ) : null}
                      </>
                  );
              })();
    };

    const productCoupons = () => {
        return (
            <>
                {vIf(goodsUsableCoupons.length > 0, <KText rtlClassName={'coupon-options-title'}>{$k18n({ text: '商品券', id: 'k_343746' })}</KText>)}
                {goodsUsableCoupons
                    ? goodsUsableCoupons.map((couponInfo, index) => {
                          return (
                              <CouponCardLarge
                                  shopInfo={shopInfo}
                                  coupon={couponInfo}
                                  updateMiniCouponInfo={refreshCouponList}
                                  itemInfo={{
                                      itemId: pageRawData.itemId,
                                  }}
                              />
                          );
                      })
                    : null}
            </>
        );
    };

    const popupContent = () => {
        return pageRawData && pageRawData.discountCoupon && (shippingUsableCoupons.length || goodsUsableCoupons.length) ? (
            <PageContext.Provider value={{ Styles }}>
                <KView
                    rtlClassName={'discountCoupon-wrapper'}
                    style={{
                        height: '75vh',
                        paddingBottom: isIOS ? 25 : 0,
                        paddingLeft: 10,
                        paddingRight: 10,
                        ...AdjustPCStyle,
                    }}>
                    <KView
                        rtlClassName={'discountCoupon-wrapper-header'}
                        style={{
                            borderBottomWidth: 0.5,
                            borderColor: 'rgba(0, 0, 0, 0.1)',
                            width: isMobileDeviceValue ? '100%' : PCMaxWidth,
                        }}>
                        <KView style={{"width":"7.246376811594203rem"}} />
                        <KView rtlClassName={'discountCoupon-wrapper-header-center'}>
                            <ViewVisible onVisible={logShowCouponPanel}>
                                <KText rtlClassName={'discountCoupon-wrapper-header-center-text'}>{$k18n({ id: 'k_322778', text: '优惠券' })}</KText>
                            </ViewVisible>
                        </KView>
                        <KTouchableWithoutFeedback
                            onPress={() => {
                                setShippingUsableCoupons([]);
                                setGoodsUsableCoupons([]);
                                closeShowMoreCouponPop();
                            }}>
                            <KView rtlClassName={'discountCoupon-wrapper-header-right'}>
                                <MyImage imageSrc={Close} styleObj={{ width: 30, height: 30 }} />
                            </KView>
                        </KTouchableWithoutFeedback>
                    </KView>
                    <KView
                        style={{
                            width: isMobileDeviceValue ? '100%' : PCMaxWidth,
                        }}
                        rtlClassName={'split-line'}
                    />
                    {couponPush.init ? (
                        <KScrollView rtlClassName={'coupon-list'} showsVerticalScrollIndicator={false}>
                            {couponPush.productCouponPriority ? productCoupons() : null}
                            {shippingCoupons()}
                            {!couponPush.productCouponPriority && productCoupons()}
                        </KScrollView>
                    ) : null}
                </KView>
            </PageContext.Provider>
        ) : (
            <PageContext.Provider value={{ Styles }}>
                <KView
                    rtlClassName={'discountCoupon-wrapper'}
                    style={{
                        height: '75vh',
                        ...AdjustPCStyle,
                    }}>
                    <CouponPopupSke />
                </KView>
            </PageContext.Provider>
        );
    };

    const onHandleCloseSpec = () => {
        setShippingUsableCoupons([]);
        setGoodsUsableCoupons([]);
        closeShowMoreCouponPop();
    };

    return isPopVisible ? (
        <>
            <Popup visible={isPopVisible} duration={150} onClose={() => onHandleCloseSpec()} position="bottom">
                {popupContent()}
            </Popup>
        </>
    ) : null;
}

export default CouponLinePop;
